import { Controller } from "@hotwired/stimulus"

// Sitewide cookie-consent banner. Persists the visitor's choice in
// localStorage so it doesn't reappear on every page load once decided.
export default class extends Controller {
  static values = { storageKey: { type: String, default: "psio_cookie_consent" } }

  connect() {
    if (this.hasConsentRecord()) {
      this.element.remove()
      return
    }

    this.element.classList.remove("hidden")
  }

  accept(event) {
    if (event) event.preventDefault()
    this.recordConsent("accepted")
  }

  decline(event) {
    if (event) event.preventDefault()
    this.recordConsent("declined")
  }

  recordConsent(value) {
    try {
      window.localStorage.setItem(this.storageKeyValue, value)
    } catch (e) {
      // localStorage unavailable (private browsing, etc.) — just dismiss for this session
    }
    this.element.remove()
  }

  hasConsentRecord() {
    try {
      return window.localStorage.getItem(this.storageKeyValue) !== null
    } catch (e) {
      return false
    }
  }
}
